import React from 'react';
import { CTAButton } from './CTAButton';
import { PriceBlock } from './PriceBlock';
export function FinalCta() {
  return <section className="bg-sand py-12 sm:py-16" data-id="element-56" data-mp="vghhfpe10dp0">
      <div className="mx-auto max-w-2xl px-5 text-center" data-id="element-57" data-mp="19ez3lioa9i4t">
        <p className="font-sans text-[0.66rem] font-semibold uppercase tracking-editorial text-gold-deep" data-id="element-58" data-mp="19gih51ik1f2w">
          Wellness Digital Pro™
        </p>
        <h2 className="mt-3 font-display text-2xl font-semibold leading-tight text-charcoal sm:text-3xl" data-id="element-59" data-mp="1jcvce3tr00zr">
          Que tu Instagram empiece a trabajar para vos
        </h2>
        <p className="mt-2 font-sans text-sm font-semibold text-charcoal/75 sm:text-base" data-id="element-60" data-mp="1ec7ldi5irk5j">
          El sistema completo + 5 bonos de implementación
        </p>

        <PriceBlock className="mt-5" size="lg" data-id="element-61" data-mp="1o568swpa54nk" />

        <div className="mt-5 flex justify-center" data-id="element-62" data-mp="223mimwifvb9x">
          <CTAButton className="w-full max-w-[24rem] px-5" data-id="element-63" data-mp="224eabw8x0oux" />
        </div>

        <p className="mt-2.5 font-sans text-[0.72rem] text-charcoal/60" data-id="element-64" data-mp="1x5b7migequq4">
          Acceso inmediato. Empezá a aplicarlo hoy.
        </p>
        <p className="mt-1 font-sans text-[0.7rem] text-charcoal/50" data-id="element-65" data-mp="n7fevn1eiyci">
          Pago seguro · Garantía 7 días
        </p>
      </div>
    </section>;
}